import React, { useEffect, useState } from 'react'
import { replicationDocumentContent, replicationNavigationItems } from '../about-page-sub-page.constants';

import './replication-guide.styl';

function ReplicationGuide() {
  const [activeSection, setActiveSection] = useState('introduction');
  
  const handleNavClick = (href, sectionId) => {
    setActiveSection(sectionId);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const renderNavItem = (item, level = 0) => {
    const isActive = activeSection === item.id;
    const hasSubItems = item.subItems && item.subItems.length > 0;

    return (
      <div key={item.id} className={`nav-item level-${level}`}>
        {hasSubItems ? (
          <div className="nav-section-header">
            <span className="nav-title">{item.title}</span>
          </div>
        ) : (
          <div
            className={`nav-link ${isActive ? 'active' : ''}`}
            onClick={() => handleNavClick(item.href, item.id)}
          >
            <div className="nav-content">
              {level === 0 && item.icon && <i className={item.icon} />}
              <span className="nav-title">{item.title}</span>
            </div>
          </div>
        )}
        {item.subItems && (
          <div className="sub-items">
            {item.subItems.map(subItem => renderNavItem(subItem, level + 1))}
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      }, 
    );

    replicationDocumentContent.forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        observer.observe(element);
      }
       
      if (section.subsections) {
        section.subsections.forEach((subsection) => {
          const subElement = document.getElementById(subsection.id);
          if (subElement) {
            observer.observe(subElement);
          }
        });
      }
    });

    return () => observer.disconnect();
  }, [])

  return (
    <div className="step-by-step-guide">
      <div className="step-by-step-guide__side side-navigation">
        <nav className="nav-menu">
          {replicationNavigationItems.map(item => renderNavItem(item))}
        </nav>
      </div>
      <div className="step-by-step-guide__main-content">
        <div className="document-content">
          {replicationDocumentContent.map(section => (
            <section>
              <h2 id={section.id}>{section.title}</h2>
              {section.paragraphs && section.paragraphs.length > 0 && (
              <p>{section.paragraphs}</p>
              )}
              {section.image && <img src={section.image} alt={section.imageAlt} />}
              {section.subsections && section.subsections.map(sub => (
                <div id={sub.id}>
                  <h3>{sub.title}</h3>
                  {sub.paragraphs && sub.paragraphs.length > 0 && (
                    <div>
                      {Array.isArray(sub.paragraphs) ? (
                        sub.paragraphs.map(paragraph => (
                          <li className="paragraph" key={paragraph}>{paragraph}</li>
                        ))
                      ) : (
                        <p>{sub.paragraphs}</p>
                      )}
                    </div>
                  )}
                  {sub.image && <img src={sub.image} alt={sub.imageAlt} />}
                </div>
              ))}
            </section>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ReplicationGuide